import React from "react";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useState, useCallback, useRef } from "react";

 

export const ActionGrid = (props) => {
    // Setting default grid params
    const gridRef = useRef();
    const gridStyle = useMemo(
        () => ({ height: "100%", width: "100%" }),
        []
    );
    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);
    const defaultColDef = useMemo(
        () => ({
            sortable: true,
            filter: true,
            resizable: true,
            animateRows: true,
        }),
        []
    );

    // Declaring the api - grid connections
    const [columnDefs, setColumnDefs] = useState([
          { field: "ClientName", headerName: 'Client name',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          suppressSizeToFit: true },
          { field: "AccountNo", headerName: 'Account No' },
          { field: "TypeCode", headerName: 'Task type' },
          { field: "ReturnStatus", headerName: 'Task description' },
          { field: "PeriodEnd", headerName: 'Period end' },
          { field: "CurrentDueDate", headerName: 'Due date' },
          { field: "Ext", headerName: 'Extension task' },
          { field: "categorized_status", headerName: 'Task' },
    ]);

    
    return (
        <div className="ag-theme-balham" style={gridStyle}>
            <AgGridReact
                ref={gridRef}
                rowData={props.rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                onGridReady={props.onGridReady}
                alwaysShowHorizontalScroll={true}
                alwaysShowVerticalScroll={true}
                sideBar={"filters"}     
                rowSelection={'multiple'}
                rowMultiSelectWithClick={true}
                onFirstDataRendered={onFirstDataRendered}
            />
        </div>
    );
};